export const FETCH = 'RECOMMENDATIONS_AUDITS/FETCH'
export const TOGGLE_ARCHIVE = 'RECOMMENDATIONS_AUDITS/TOGGLE_ARCHIVE'
export const SETUP_FILTERS = 'RECOMMENDATIONS_AUDITS/SETUP_FILTERS'

export const FETCH_NOTIFICATIONS = 'RECOMMENDATIONS_AUDITS/FETCH_NOTIFICATIONS'

export const QUERY_TYPE = 'RECOMMENDATIONS_AUDITS/QUERY_TYPE'

export const SET_RECOMMENDATIONS = 'RECOMMENDATIONS_AUDITS/SET_RECOMMENDATIONS'

export const UPDATE = 'RECOMMENDATIONS_AUDITS/UPDATE'

export const SET_ARCHIVE_PROCESSING_IDS = 'RECOMMENDATIONS_AUDITS/SET_ARCHIVE_PROCESSING_IDS'

export const REMOVE_FROM_LIST = 'RECOMMENDATIONS_AUDITS/REMOVE_FROM_LIST'

export const SET_FILTER = 'RECOMMENDATIONS_AUDITS/SET_FILTER'

export const SET_FILTERS = 'RECOMMENDATIONS_AUDITS/SET_FILTERS'

export const SET_NOTIFICATIONS = 'RECOMMENDATIONS_AUDITS/SET_NOTIFICATIONS'

export const DROP_LIST = 'RECOMMENDATIONS_AUDITS/DROP_LIST'

export const SEEN = 'RECOMMENDATIONS_AUDITS/SEEN'
